import React from "react"
import { actionKeys } from "@love-irish/i18n"
import { IconDeviceTv } from "@tabler/icons-react"
import BaseListItem from "../base"

export interface TVShowListItemProps {
  item: Record<string, any>
  className?: string
  /** Custom footer content to replace the default "Added by..." text */
  footer?: React.ReactNode
}

export const TVShowListItem: React.FC<TVShowListItemProps> = ({ item, className, footer }) => (
  <BaseListItem
    item={item}
    className={className}
    footer={footer}
    typeIcon={IconDeviceTv}
    typeLabel="TV Show"
    testId="tv-show-list-item"
    readMore={{ useI18n: true, actionKey: actionKeys.WATCH }}
    media={
      (item.imageUrl || item.thumbnailUrl) && (
        <a href={item.path}>
          <img loading="lazy"
            src={item.thumbnailUrl || item.imageUrl}
            alt={item.name}
            className="max-w-[100px] rounded-xl"
          />
        </a>
      )
    }
  />
)

export default TVShowListItem
